__turbopack_context__.v({
  "carousel": "Carousel-module-scss-module__diEpua__carousel",
  "slide": "Carousel-module-scss-module__diEpua__slide",
});
